var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95339 6.58C10.0352 6.66196 10.0812 6.77317 10.0814 6.88916V7.11083C10.08 7.22657 10.0342 7.33733 9.95339 7.42L6.96372 10.4125C6.90912 10.4677 6.83478 10.4988 6.75724 10.4988C6.67969 10.4988 6.60536 10.4677 6.55075 10.4125L6.13778 9.99833C6.08307 9.94457 6.05224 9.87098 6.05224 9.79416C6.05224 9.71734 6.08307 9.64376 6.13778 9.59L8.72611 7L6.13778 4.41C6.08273 4.35523 6.05176 4.28068 6.05176 4.20291C6.05176 4.12514 6.08273 4.05059 6.13778 3.99583L6.55075 3.5875C6.60536 3.53228 6.67969 3.50122 6.75724 3.50122C6.83478 3.50122 6.90912 3.53228 6.96372 3.5875L9.95339 6.58Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.227eff2a7d71e17af67910acd11898ae.svg";
export { ForwardRef as ReactComponent };